<template>
    <div class="flex flex-col justify-center items-center p-4">
        <div v-for="(item, index) in items" class="border-2 p-3 rounded-md flex w-2/4 relative mb-3" :key="index">
            <div class="mr-4">
                <img class="bg-secondary rounded-full w-32 h-32 object-cover" :src="item.exhibitor.profileImage" />
            </div>
            <div>
                <div class="text-3xl font-bold mb-2">{{ item.exhibitor.name }}</div>
                <div class="text-lg font-bold">{{ item.title }}</div>
            </div>
            <div class="absolute -top-2 -right-2 bg-primary text-white rounded-full px-2 py-1 font-bold text-lg flex justify-center">
                {{ item.votedVisitors.length }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            items: [],
        };
    },

    async mounted() {
        this.retrieveData();
    },

    methods: {
        async retrieveData() {
            const response = await this.httpRequest(`/organizer/event/${this.$route.params.id}/voting`, 'get');
            if (response.result === 'success') {
                const items = this.replaceUrl(response.data.itProducts);
                this.items = items;
            }
        },
    },
}
</script>